import { useState } from 'react';
import apiFetch from '@wordpress/api-fetch';
import { Alert, CircularProgress } from '@mui/material';
import { Input, Submit } from '../../../shared/components/form';

import style from './style.module.scss';
import { __ } from '../../../shared/tools';

export const ProductStockAlertForm = ({ productId }) => {
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const requestData = {
            post_id: productId,
            email: e.target.email.value,
        };

        apiFetch({
            path: 'paraboot/api/stock-alert',
            method: 'POST',
            data: requestData,
        }).then(
            () => {
                setAlert({
                    type: 'success',
                    msg: __(
                        'Votre inscription a bien été prise en compte. Vous recevrez un email lorsque le produit sera à nouveau en stock.',
                    ),
                });
                setLoading(false);
            },
            (err) => {
                setAlert({
                    type: 'error',
                    msg: __("Une erreur s'est produite durant l'inscription. Veuillez réessayer."),
                });
                setLoading(false);
            },
        );
    };

    return (
        <form onSubmit={handleSubmit} className={style.form} method="post">
            <div className={style.inputGroup}>
                <Input
                    name="email"
                    placeholder={__('Saissez votre email')}
                    id="product_stock_alert_form_email"
                    required={true}
                    type="email"
                />
                <Submit buttonText={__("M'alerter")} className={style.submit} disabled={loading} />
            </div>
            {loading && <CircularProgress className={style.progress} />}
            {alert && (
                <Alert severity={alert.type} className={style.alert}>
                    {alert.msg}
                </Alert>
            )}
        </form>
    );
};

export default ProductStockAlertForm;
